import { ClothingItem } from "../types";

export const initialItems: ClothingItem[] = [
  {
    id: "1",
    name: "Faux Leather Double-Breasted Blazer",
    brand: "Topshop",
    color: "black",
    category: "top",
    subcategories: ["jacket", "smart casual", "business casual"],
    status: "PURCHASED",
    storeUrl: "https://www.asos.com/topshop/topshop-faux-leather-double-breasted-blazer/",
    images: [
      "/lovable-uploads/53bccb7e-70cf-41d1-bfc8-148716a8421c.png",
      "/lovable-uploads/61ec31b3-82a0-458c-ae2e-21253c5864be.png",
      "/lovable-uploads/7627e58a-c53c-4b53-aa95-8f16032aaca0.png"
    ]
  },
  {
    id: "2",
    name: "Speed Up High-Rise Short 4\"",
    brand: "Lululemon",
    color: "black",
    category: "bottom",
    status: "PURCHASED",
    images: ["/placeholder.svg"]
  },
  {
    id: "3",
    name: "Hotty Hot High-Rise Short 4\"",
    brand: "Lululemon",
    color: "navy",
    category: "bottom",
    status: "PURCHASED",
    images: ["/placeholder.svg"]
  },
  {
    id: "4",
    name: "Rainbow Narrow Strap Womens Sandals",
    brand: "Rainbow",
    color: "brown",
    category: "shoes",
    status: "PURCHASED",
    images: ["/placeholder.svg"]
  }
];
